<template>
    <!-- <div class="CourseSingupModalWarp"> -->
    <!-- 显示报名 -->
    <el-dialog title="" :visible.sync="singupVisible" width="1200px" class="dialogWarp" @closed="offmodalFn" :destroy-on-close="true"
        :close-on-click-modal='false' :append-to-body="true">
        <div class="singupdialogcenter">
            <h3>报名表</h3>
            <div class="singupForm">
                <el-form v-for="(val,i) in datalist" :key="i" :model="val" :rules="formrules" ref="formData" label-width="130px" class="demo-dynamic">
                  
                    <div class="formdatabox">
                        <div class="indexbox" @click="deleteFn(i)">序号：{{i+1}}
                            <i v-if="i!=0" class="deleteicon el-icon-remove-outline" />
                        </div>
                        <div class="datawarp">
                            <div v-for="(item,index) in formList" :key="index" class="formitembox">
                                <el-form-item :label="item.templateName" :prop="item.templateCode" :rules="[
                                {required:item.isRequired=='true'?true:false,message: '请输入', trigger: 'blur' }
                                ]" v-if="item.templateType=='input'">
                                    <el-input placeholder="请输入" v-model="val[item.templateCode]"></el-input>
                                </el-form-item>
                                <el-form-item :label="item.templateName" :prop="item.templateCode" v-if="item.templateType=='select'" :rules="[
                                {required:item.isRequired=='true'?true:false,message: '请选择', trigger: 'change' }
                                ]">
                                    <el-select v-model="val[item.templateCode]" placeholder="请选择" style="width:100%">
                                        <el-option v-for="(ele,index) in item.templateOption" :key="index" :label="ele" :value="ele">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item :label="item.templateName" :prop="item.templateCode" v-if="item.templateType=='date'" :rules="[
                                {required:item.isRequired=='true'?true:false,message: '请选择日期', trigger: 'change' }
                                ]">
                                    <el-date-picker v-model="val[item.templateCode]" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择日期"
                                        style="width:100%">
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item :label="item.templateName" :prop="item.templateCode" v-if="item.templateType=='checkbox'" :rules="[
                                {required:item.isRequired=='true'?true:false,message: '请选择', trigger: 'change' }
                                ]">
                                    <!-- <el-radio-group v-model="val[item.templateCode]">
                                        <el-radio :label="ele" v-for="(ele,index) in item.templateOption" :key="index">{{ele}}</el-radio>
                                    </el-radio-group> -->
                                    <el-checkbox-group v-model="val[item.templateCode]">
                                        <el-checkbox v-for="(ele,index) in item.templateOption" :label="ele" :key="index" name="type">{{ele}}</el-checkbox>
                                    </el-checkbox-group>
                                </el-form-item>
                                <el-form-item :label="item.templateName" :prop="item.templateCode" v-if="item.templateType=='upload'" :rules="[
                                {required:item.isRequired=='true'?true:false,message: '请上传附件', trigger: 'change' }
                                ]">
                                    <el-upload multiple :on-success="fileSuccessFn(i,item.templateCode)" :on-remove="fileRemoveFn(i,item.templateCode)" :action="actionUrl"
                                        :file-list="fileList[i]">
                                        <i class="el-icon-upload upicon"></i>
                                    </el-upload>
                                    <!-- <UploadFile v-model="val[item.templateCode]" allclass="passport-uploader" inclass="passport-uploader-icon passport-s3" onclass="passport passport-pic">
                                        <div class="el-upload__tip" slot="tip">请上传300*420像素不超过500K大小的图片,图片格式支持.PNG或.JPG</div>
                                    </UploadFile> -->
                                </el-form-item>
                            </div>
                        </div>
                    </div>
                </el-form>
                <div class="btnwarp">
                    <div @click="addDomain" class="addbtn"><i class="el-icon-circle-plus-outline" /> 增加报名人数</div>
                </div>
                <div class="formBtnBox">
                    <el-button type="primary" @click="submitForm" class="submitBtn" :loading="isloading">提交</el-button>
                    <el-button @click="offmodalFn" class="cancelBtn">取消</el-button>
                </div>
            </div>
        </div>
    </el-dialog>
    <!-- </div> -->
</template>
<script>
import { httpService, srcUrl } from "@/service/httpService";
import { formErrorScroll } from '@/utils'
import UploadFile from '@/components/uploadFile'
export default {
    components: {
        UploadFile
    },
    props: ['isShow', 'confereeCode', 'confereeName'],
    data() {
        return {
            singupVisible: true,
            formData: {},
            formList: [],
            formrules: {},
            addForm: {
                confereePeople: []
            },
            datalist: [],
            formDataValue: {},
            isloading: false,
            fileList: [],
            actionUrl: process.env.VUE_APP_GATEWAY + '/upload/addfile',
        }
    },
    created() {
        this.getformFn()
    },
    methods: {
        // 获取表单
        async getformFn() {
            let data = await httpService.getTemplateOption(this.confereeCode);
            if (data.code == 200) {
                this.formList = data.result
                let obj1 = {}
                let obj = {}
                let rulesobj = {}
                this.formList.forEach(ele => {
                    if (ele.templateOption) {
                        ele.templateOption = ele.templateOption.split(',')
                    }
                    // 表单对象
                    if (ele.templateType == 'checkbox') {
                        obj[ele.templateCode] = []
                        obj1[ele.templateCode] = []
                    } else {
                        obj[ele.templateCode] = ''
                        obj1[ele.templateCode] = ''
                    }
                    // 验证表单对象
                    if (ele.isRequired == 'true') {
                        if (ele.templateType == 'select') {
                            rulesobj[ele.templateCode] =
                                [{ required: true, message: '请选择', trigger: 'change' }]

                        } else if (ele.templateType == 'input') {
                            rulesobj[ele.templateCode] =
                                [{ required: true, message: '请输入', trigger: 'blur' }]
                        }
                        else if (ele.templateType == 'date') {
                            rulesobj[ele.templateCode] =
                                [{ required: true, message: '请选择日期', trigger: 'change' }]
                        }
                        else if (ele.templateType == 'checkbox') {
                            rulesobj[ele.templateCode] =
                                [{ required: true, message: '请选择', trigger: 'change' }]
                        } else if (ele.templateType == 'upload') {
                            rulesobj[ele.templateCode] =
                                [{ required: true, message: '请上传附件', trigger: 'change' }]
                        }
                    }
                })
                this.formData = obj
                this.formDataValue = obj1
                this.addForm.confereePeople.push(obj)
                this.formrules = rulesobj
                this.datalist.push(this.formData)
            }
        },
        // 报名表单
        submitForm() {
            // let flag = false
            let flagnum = 0
            this.$refs['formData'].forEach(ele => {
                ele.validate((valid) => {
                    if (valid) {
                        // return
                        flagnum = flagnum + 1
                        if (flagnum == this.$refs['formData'].length) {
                            this.isloading = true
                            this.datalist.forEach(item => {
                                for (const key in item) {
                                    if (item[key] instanceof Array) {
                                        item[key]=item[key].join()
                                    }
                                }
                            });
                            let params = {
                                confereeCode: this.confereeCode,
                                confereeName: this.confereeName,
                                confereePeople: this.datalist
                            }
                            httpService.addConference(params).then(res => {
                                if (res) {
                                    this.isloading = false
                                    if (res.code == 200) {
                                        this.$message({
                                            message: '会议报名成功',
                                            type: 'success'
                                        });
                                        this.$emit('update:isShow', false)
                                        if (!this.isCustom) this.$destroy() // 销毁当前组件
                                    } else {
                                        this.$message.error(res.message);
                                    }
                                }
                            })
                        }
                        // flag=true
                    } else {
                        this.$nextTick(() => {
                            formErrorScroll()
                        })
                        return false;
                    }
                });
            })
            // if(flag){
            //     this.isloading = true
            //     let params = {
            //         confereeCode: this.confereeCode,
            //         confereeName: this.confereeName,
            //         confereePeople: this.datalist
            //     }
            //     httpService.addConference(params).then(res => {
            //         if(res){
            //             this.isloading = false
            //             if (res.code == 200) {
            //                 this.$message({
            //                     message: '会议报名成功',
            //                     type: 'success'
            //                 });
            //                 this.$emit('update:isShow', false)
            //                 if (!this.isCustom) this.$destroy() // 销毁当前组件
            //             }else{
            //                 this.$message.error(res.message);
            //             }
            //         }
            //     })
            // }
        },
        // 关闭表单
        offmodalFn() {
            this.$emit('update:isShow', false)
            if (!this.isCustom) this.$destroy() // 销毁当前组件
        },
        addDomain() {
            // stringify
            let val = JSON.parse(JSON.stringify(this.formDataValue))
            this.datalist.push(val)
        },
        deleteFn(index) {
            this.datalist.splice(index, 1)
        },
        // 附件
        fileSuccessFn(i, templateCode) {
            return (res, file, fileList) => {
                if (res.code == 200) {
                    this.fileList[i] = fileList
                    let filearr = []
                    this.fileList[i].map(item => {
                        if (item.response) {
                            return filearr.push(item.response.result)
                        } else {
                            return filearr.push(item.name)
                        }
                    })
                    this.datalist[i][templateCode] = filearr.join(',')
                }
            }
        },
        fileRemoveFn(i, templateCode) {
            return (file, fileList) => {
                this.fileList[i] = fileList
                let filearr = []
                this.fileList[i].map(item => {
                    if (item.response) {
                        return filearr.push(item.response.result)
                    } else {
                        return filearr.push(item.name)
                    }
                })
                this.datalist[i][templateCode] = filearr.join(',')
            }
        },
    }

}
</script>
<style lang="less" scoped>
// 课程相关
.dialogWarp {
	/deep/.singupdialogcenter {
		padding: 17px 60px 0px 60px;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
		align-items: center;
		h3 {
			font-size: 22px;
			font-weight: bold;
			line-height: 32px;
			color: #333333;
			margin-bottom: 32px;
		}

		.courseBox1 {
			width: 100%;
			display: flex;
			flex-direction: row;
			justify-content: center;
			padding-bottom: 32px;
			border-bottom: 1px solid #dddddd;
			margin-bottom: 20px;
			.courseinfo {
				margin: 0 132px;
				font-size: 16px;
				line-height: 54px;
				color: #333333;
				.text {
					font-size: 16px;
					margin-right: 20px;
					line-height: 54px;
					color: #a6a9b7;
				}
			}
		}
		/deep/.el-checkbox__inner {
			border-radius: 50%;
		}
		.singupForm {
			width: 100%;
			// display: flex;
			//     flex-direction: row;
			//     flex-wrap: wrap;
			.formdatabox {
				width: 100%;
				display: flex;
				flex-direction: column;
				border-bottom: 1px dashed #ddd;
				padding: 10px 0 16px 0;
				.indexbox {
					margin: 0 0 16px 85px;
					font-size: 16px;
					cursor: pointer;
					.deleteicon {
						color: red;
						margin-left: 10px;
					}
				}
				.datawarp {
					display: flex;
					flex-direction: row;
					flex-wrap: wrap;
					.formitembox {
						width: 48%;
						margin-right: 1%;
						&:nth-child(2n) {
							margin-right: 0;
						}
					}
				}
			}
			.btnwarp {
				font-size: 16px;
				line-height: 54px;
				display: flex;
				flex-direction: row;
				justify-content: center;

				.icon {
					margin-right: 5px;
				}
				.addbtn {
					color: #0083ff;
					margin: 0 20px;
					cursor: pointer;
				}
				.deletebtn {
					color: #ff3c3c;
					margin: 0 20px;
					cursor: pointer;
				}
			}
			.formBtnBox {
				display: flex;
				fill-opacity: row;
				justify-content: center;
				.submitBtn {
					width: 152px;
					height: 40px;
					background: #349cff;
					margin: 0 20px;
				}
				.cancelBtn {
					width: 152px;
					height: 40px;
					border: 1px solid #a6a9b7;
					border-radius: 5px;
					margin: 0 20px;
				}
			}
		}
	}
}
</style>


